import {LoanPaymentMethod} from 'src/products/loans/MakePayment/LoanPay.types'
import Log from 'src/lib/loggingUtil'
import {PaymentMethodTypeForAnalytics} from 'src/products/general/GeneralPaymentMethods/types'
import {logErrorAndShowException} from 'src/lib/errors'
import {aggregatorsId} from 'src/lib/user/userEnvConsts'
import {banking} from '@possible/generated/proto'

export const logAddPaymentMethodError = (error: unknown, message?: string): void => {
  const addPaymentSuffix = 'Add Payment Method'

  // Add suffix to error message
  if (error instanceof Error) {
    error.message = `${error.message} - ${addPaymentSuffix}`
  } else {
    // If for some reason, error is not an instance of Error, log the message with the suffix
    message = message ? `${message} - ${addPaymentSuffix}` : addPaymentSuffix
  }

  Log.error(error, message)
}

export const logAddPaymentMethodErrorAndShowException = (
  error: unknown,
  message?: string,
): void => {
  const addPaymentSuffix = 'Add Payment Method'

  // Add suffix to error message
  if (error instanceof Error) {
    error.message = `${error.message} - ${addPaymentSuffix}`
  } else {
    // If for some reason, error is not an instance of Error, log the message with the suffix
    message = message ? `${message} - ${addPaymentSuffix}` : addPaymentSuffix
  }
  void logErrorAndShowException(error, message)
}

export const getPaymentMethodTypeForAnalytics = (
  paymentMethod: LoanPaymentMethod,
): PaymentMethodTypeForAnalytics | undefined => {
  if (paymentMethod?.__typename === 'DebitCardPaymentMethod') {
    return 'debit_card'
  } else if (paymentMethod?.__typename === 'AchPaymentMethod') {
    if (paymentMethod.account) {
      return 'ach_linked_with_aggregator'
    } else {
      return 'ach_routing_account'
    }
  }
}

export const convertAggregatorStringToType = (
  aggregatorIdStr: string | undefined | null,
): aggregatorsId | undefined => {
  if (aggregatorIdStr === aggregatorsId.plaid.valueOf()) {
    return aggregatorsId.plaid
  } else if (aggregatorIdStr === aggregatorsId.yodlee.valueOf()) {
    return aggregatorsId.yodlee
  } else if (aggregatorIdStr === aggregatorsId.mocked.valueOf()) {
    return aggregatorsId.mocked
  }
  return undefined
}

const accountLinked = 'linked'
const accountLinkedInUse = 'linked_in_use'

const isLinkedAccount = (
  account: banking.ILinkedAccount | string | undefined,
): account is banking.ILinkedAccount => {
  return account !== undefined && typeof account === 'object' && 'isLoginRequired' in account
}

export const getAccountId = (
  account: banking.ILinkedAccount | string | undefined,
): string | undefined => {
  if (
    isLinkedAccount(account) &&
    account.isLoginRequired === true &&
    (account.status === accountLinked || account.status === accountLinkedInUse)
  ) {
    return account.id
  }
  return undefined
}
